import { render, staticRenderFns } from "./BtnTabs.vue?vue&type=template&id=e6ecc190&scoped=true"
import script from "./BtnTabs.vue?vue&type=script&lang=js"
export * from "./BtnTabs.vue?vue&type=script&lang=js"
import style0 from "./BtnTabs.vue?vue&type=style&index=0&id=e6ecc190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ecc190",
  null
  
)

export default component.exports